import React from "react";
import { useNavigate } from "react-router-dom";
import { PageContainer } from "shared";
import { Button } from "components";

export default function Error() {
  const navigate = useNavigate();

  return (
    <PageContainer disableNavbarBottom>
      <div className="m-auto h-full w-full md:w-2/3 lg:w-1/3">
        <div className="relative flex flex-col items-center justify-center rounded-lg border border-gray-200 bg-white p-6 text-center shadow-card-box">
          <div className="text-9xl">
            <span className="font-bold text-primary">4</span>
            <span className="font-bold text-slate-200">0</span>
            <span className="font-bold text-primary">4</span>
          </div>
          <div className="my-8">
            <h4 className="text-lg font-bold">Oops! Page cannot be found</h4>
          </div>

          <div className="m-auto mt-2 text-center">
            <Button
              label="Go back"
              fullWidth
              gradient
              handleClick={() => {
                navigate(-1);
              }}
            />
          </div>
        </div>
      </div>
    </PageContainer>
  );
}
